import React from "react";
// mui 5
import Box from "@mui/system/Box";
import Chip from "@mui/material/Chip";
import { colors } from "@mui/material";
// custom style
import { StyledPokemonTypes, StyledTypogrophy } from "./styledComponents";

const ColorMap = {
  grass: colors.lightGreen[400],
  poison: colors.purple[400],
  water: colors.blue[800],
  flying: colors.blue[400],
  ice: colors.lightBlue[400],
  ground: colors.brown[600],
  fire: colors.orange[800],
  bug: colors.green[400],
  psychic: colors.pink[400],
};

function PokemonTypes({ types }) {
  return (
    <StyledPokemonTypes>
      <StyledTypogrophy variant="body2">Types</StyledTypogrophy>
      <Box>
        {types.slice(0, 2).map((type) => (
          <Chip
            key={type}
            label={type}
            size="small"
            // variant="outlined"
            sx={{ mr: 1, backgroundColor: ColorMap[type] || colors.grey[100] }}
          />
        ))}
      </Box>
    </StyledPokemonTypes>
  );
}

export default PokemonTypes;
